import Button from "components/Buttons/Button";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const ScrollTo = ({ text, to }) => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  });
  return (
    <div className="">
      <Link
        to={to}
        className="px-4 py-2 font-poppins font-bold  text-lg rounded-lg bg-secundario text-bluegray-900 outline outline-2 outline-bluegray-900 focus:ring-4 focus:ring-bluegray-900 focus:outline-none transition-colors duration-300"
      >
        {text}
      </Link>
    </div>
  );
};

export default ScrollTo;
